/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An organization-owned user_session_issuer that uses a remote_session_issuer as its trust anchor.
 */
export type TrustedUserSessionIssuerReference = {
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * The user_session_issuer slug.
   */
  slug: string;
};

/** @internal */
export const TrustedUserSessionIssuerReference$inboundSchema: z.ZodMiniType<
  TrustedUserSessionIssuerReference,
  unknown
> = z.object({
  id: z.string(),
  slug: z.string(),
});

export function trustedUserSessionIssuerReferenceFromJSON(
  jsonString: string,
): SafeParseResult<TrustedUserSessionIssuerReference, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TrustedUserSessionIssuerReference$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TrustedUserSessionIssuerReference' from JSON`,
  );
}
